import script from "./ListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ListItem.vue?vue&type=style&index=0&id=4061f960&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4061f960"]])

export default __exports__